<template>
    <div class="wrapper-div">
        <div class="videos-dialog extend-bottom" :style="{ 'max-width': width + 'px' }">
            <div style="position: relative; top: 42px; left: 20px; width: calc(100% - 40px)">
                <IconBtn
                    v-if="hasHistory"
                    @click="stepBackHistory"
                    class="primary-outlined closeBtnWrapper"
                    name="arrow-left"
                    size="lg"
                    style="float: left"
                />
                <IconBtn
                    class="primary-outlined closeBtnWrapper"
                    name="times"
                    size="lg"
                    style="float: right"
                    @click="closeDialog"
                />
            </div>
            <Paper
                style="width: 100%"
                class="d-flex flex-column flex-grow"
                :header="payload.title"
                :offsetHeaderFromLeft="hasHistory"
                restrictHeaderWidth
            >
                <div class="video-root pb-7 video-layout flex-grow">
                    <div
                        class="wistia_responsive_padding"
                        style="padding:56.25% 0 0 0;position:relative;"
                    >
                        <div
                            class="wistia_responsive_wrapper"
                            style="height:100%;left:0;position:absolute;top:0;width:100%;"
                        >
                            <div
                                class="wistia_embed videoFoam=true"
                                :class="`wistia_async_${videoLink}`"
                                style="height:100%;position:relative;width:100%"
                            >
                                <div
                                    class="wistia_swatch"
                                    style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
                                >
                                    <img
                                        :src="
                                            `https://fast.wistia.com/embed/medias/${videoLink}/swatch`
                                        "
                                        style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                                        onload="this.parentNode.style.opacity=1;"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <slot />
            </Paper>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Videos.Dialog',

    props: {
        videoLink: String,
    },

    data() {
        return {
            width: 600,
            height: 600,
        };
    },

    computed: {
        payload() {
            return this.$interfaces.dialogModal.getState().payload;
        },

        hasHistory() {
            return this.$interfaces.dialogModal.hasHistory();
        },
    },

    methods: {
        closeDialog() {
            this.$interfaces.dialogModal.getState().resolver.res();
        },

        handleResizeEvent() {
            this.height = window.innerHeight * 0.9;
            this.width = window.innerWidth;
        },

        stepBackHistory() {
            this.$interfaces.dialogModal.popState();
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },
};
</script>

<style lang="css" scoped>
.video-root {
    padding: 3rem !important;
}

.videos-dialog {
    margin: 0 auto;
    max-width: var(--grid-width);
    width: var(--grid-width);
}

.wrapper-div {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

@media only screen and (max-width: 600px) {
    .video-root {
        padding: 0px !important;
    }
}
</style>
